
import 'devextreme/data/odata/store';
import { accountIntegrationTenantApiSecurityService } from '@/projects/admin/services/account-integration-tenant-api-security-service';
import { useRef, useState } from "react";
import { t } from 'i18next';
import DataGridWrapper from "@/core/wrappers/data-grid-wrapper";
import { DataGrid } from 'devextreme-react';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';
import { useNavigate } from 'react-router-dom';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';

const cellPrepared = (e: any) => {
    if (e.rowType === "data") {
        if (e.column.dataField === "lastProcessStatus") {
            if (e.data.lastProcessStatus == "Başarısız") {
                e.cellElement.style.cssText = "color: red !important; ";
            }
            else {
                e.cellElement.style.cssText = "color: green !important; ";
            }
        }
    }
}


function IntegrationTenantApiSecurityList() {
    const dataGridRef = useRef<DataGrid>(null);

    const [mainStore] = useState(() =>
        createCustomStore({
            key: ['id'],
            load: accountIntegrationTenantApiSecurityService.getTenantApiSecurityList,
            byKey: (key, loadOptions) => {
            },
            useDefaultSearch: true,
            remove: accountIntegrationTenantApiSecurityService.deleteTenantApiSecurity,
        }));
    const navigate = useNavigate();

    const goToEdit = (id: string) => {
        navigate(`/admin/account-tenant-api-security-definition/${id}`, { state: { id: id } })
    }
    return (
        <>
            <DataGridWrapper
                props={{ id: 'tenant-api-security-list', ref: dataGridRef, wordWrapEnabled: true }}
                permissonCode='Admin.Account.TenanApiSecurity'
                datasource={mainStore}
                editingConfig={{
                    allowUpdating: true,
                    allowDeleting: true,
                    confirmDelete: true,
                    confirmDeleteMessage: RemoveMessage(t('tenant-api-security')),
                }}
                pagerVisible={true}
                headerFilterVisible={true}
                filterVisible={true}
                enableCustomToolbarContent={true}
                navigateNewRecordPath='/admin/account-tenant-api-security-definition'
                columns={[
                    {
                        dataField: "id",
                        visible: false,
                    },
                    {
                        dataField: 'tenantId',
                        caption: t('tenant_id'),
                    },
                    {
                        dataField: 'tenantName',
                        caption: t('retailer'),
                    }, {
                        dataField: 'timestampIsActive',
                        caption: t('timestamp_is_active'),
                    },
                    {
                        dataField: 'timestampPrivateKey',
                        caption: t('timestamp_private_key'),
                    },
                    {
                        dataField: 'timestampAllowedTimeDifferenceInSeconds',
                        caption: t('timestamp_allowe_time_difference_in_seconds'),
                    },
                    {
                        dataField: 'requestBodyHashIsActive',
                        caption: t('request_body_hash_is_active'),
                    },

                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: (e: any) => goToEdit(e.row?.data.id),
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
            />
        </>
    )
}

export default IntegrationTenantApiSecurityList;